import { render, staticRenderFns } from "./GraphDetail42.vue?vue&type=template&id=2cc0a1c0&scoped=true"
import script from "./GraphDetail42.vue?vue&type=script&lang=js"
export * from "./GraphDetail42.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0a1c0",
  null
  
)

export default component.exports